import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col, Input, message, Select } from "antd";
//redux
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { loginUser, resetLoginFlag } from "../../store/actions";
import LoadingPage from "../../Components/Common/LoadingPage";
import loginBg from "../../assets/images/login-bg.svg";
import logo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import { languageOptions } from "../../common/languageOptions";

const { Option } = Select;

const Login = (props) => {
  document.title = "OKACE HRM";
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => ({
    user: state.Account.user,
    loading: state.Login.loading,
  }));
  const { error, status } = useSelector((state) => ({
    error: state.Login.error,
    status: state.Login.status,
  }));
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    setCurrentLanguage(lng);
  };

  useEffect(() => {
    setTimeout(() => {
      dispatch(resetLoginFlag());
    }, 5000);
    if (error && status) {
      if (status === 2) {
        message.error(t("wrongPassword"));
      } else if (status === 3) {
        message.error(t("blockUser"));
      } else if (status === 4) {
        message.error(t("emptyUsername"));
      } else if (status === 5) {
        message.error(t("errorLoginMobile"));
      } else {
        message.error(t("errorLogin"));
      }
    }
  }, [error]);

  const handleSubmitForm = async (dataUser) => {
    try {
      var data_submit = {
        ...dataUser,
      };

      dispatch(loginUser(data_submit, props.history));
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <LoadingPage loading={loading} />
      <div className="auth-page-content">
        <div className="">
          <img width={100} className="logo-image" src={logo} alt="" />
          <Row className="" gutter={0}>
            <Col md={17} className="auth-left-bg p-5 d-none-sm">
              <img className="img-fluid" src={loginBg} alt="" />
            </Col>
            <Col md={7} className="auth-tight align-items-center d-flex">
              <div className="mt-4 login">
                <div className="p-5 ">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">{t("title_login")} 👋</h5>
                  </div>
                  <div className="p-2 mt-4">
                    <Form
                      form={form}
                      onFinish={handleSubmitForm}
                      autoComplete="off"
                    >
                      <div className="mb-3">
                        <Form.Item
                          name="username"
                          label={t("userName") + " :"}
                          rules={[
                            {
                              required: true,
                              message: t("errorEmptyUserName"),
                              type: "string",
                              min: 1,
                            },
                          ]}
                          style={{ marginBottom: "22px" }}
                        >
                          <Input
                            placeholder={t("placeHolderUserName")}
                            allowClear={true}
                          />
                        </Form.Item>
                      </div>

                      <div className="mb-3">
                        <Form.Item
                          name="password"
                          label={t("password") + " :"}
                          rules={[
                            {
                              required: true,
                              message: t("errorEmptyPassword"),
                            },
                          ]}
                          style={{ marginBottom: "22px" }}
                        >
                          <Input.Password
                            placeholder={t("placeHolderPassword")}
                            allowClear={false}
                          />
                        </Form.Item>
                      </div>
                      <Select value={currentLanguage} onChange={changeLanguage}>
                        {Object.keys(languageOptions).map((value) => (
                          <Option key={value} value={value}>
                            {t(`languageOptions.${value}`)}
                          </Option>
                        ))}
                      </Select>
                      <div className="mt-5">
                        <Button
                          disabled={loading}
                          color="secondary"
                          className="btn btn-secondary w-100"
                          htmlType="submit"
                        >
                          {t("login").toUpperCase()}
                        </Button>
                      </div>

                      <div className="mt-4"></div>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default withRouter(Login);
